import { NgClass } from '@angular/common'
import { Component, input, OnInit, signal } from '@angular/core'

@Component({
  selector: 'app-mobile-collapsible-section',
  standalone: true,
  imports: [NgClass],
  templateUrl: './mobile-collapsible-section.component.html',
  styleUrl: './mobile-collapsible-section.component.scss'
})
export class MobileCollapsibleSectionComponent implements OnInit {
  public readonly title = input.required<string>()
  public readonly initialExpanded = input(false)
  public readonly showOnDesktop = input(false)
  public readonly isExpanded = signal(false)

  ngOnInit(): void {
    this.isExpanded.set(this.initialExpanded())
  }

  /**
   * Toggles the collapsible section.
   */
  public toggleSection(): void {
    this.isExpanded.update((expanded) => !expanded)
  }
}
